import Lines from '../../components/common/Lines';
import ProgressScroll from '../../components/common/ProgressScroll';
import Cursor from '../../components/common/cusor';
import LoadingScreen from '../../components/common/loader';
import { Footer } from './Footer';
import { Outlet } from 'react-router-dom';
import { ThemeNavbar } from './ThemeNavbar';

export function ThemeLayout() {
  return (
    <>
      <LoadingScreen />
      <Cursor />
      <ProgressScroll />
      <Lines />
      <ThemeNavbar />
      <div id="smooth-wrapper" className="elenardThemeShell">
        <div id="smooth-content">
          <main className="main-bg o-hidden">
            <Outlet />
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
}

